import React, { useContext, useEffect, useState } from 'react';
import { QuizIntroduction } from './../../components/QuizIntroduction';
import { QuizQuestion } from './../../components/QuizQuestion';
import gameContext from './../../contexts/gameContext'; 
import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';

export const QuizContainer = () => {
    const { config, modules, message } = useContext(gameContext);
    let [firstLoad, setFirstLoad] = useState(true)
    
    const quizConfig = (config.quiz || {})
    let startIndex = quizConfig.showIntro ? -1 : 0
    let systemId = message.systemId
    let overwriteIndex = lodashGet(modules.realDevice, "variables.quizContainerPackage.systemId_"+systemId+".currentPosition")
    
    if(overwriteIndex && firstLoad && config.quiz.rememberPositionForQuiz){
        console.log('Continued to index : ', overwriteIndex)
        startIndex = overwriteIndex
        setFirstLoad(false)
    }
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState({ index:  startIndex , history : [] });
    let quizModules = []
    for(let questionIndex = 0; questionIndex < config.questions.length; questionIndex++) {
        let subPackageModules = {}
        subPackageModules = copyObj(subPackageModules, modules)
        subPackageModules.device = cloneDeep(modules.device)
        subPackageModules.navigation = cloneDeep(modules.navigation)
        subPackageModules.device.quizContainerOriginalTriggerOutcome = subPackageModules.device.triggerOutcome
        subPackageModules.parent = { message : message }
        let question = config.questions[questionIndex]
        
        function nextFn () {
            console.log("navigation.next", questionIndex)
            resolveNextQuestion(question, questionIndex, null, config.questions.length)
        }
        
        function prevFn() {
            let prevIndex = currentQuestionIndex.history.pop()
            setCurrentQuestionIndex({ index : prevIndex, history : currentQuestionIndex.history })
            resolveNextQuestion(question, questionIndex, null, config.questions.length)
        }
        
        subPackageModules.navigation.next = nextFn
        subPackageModules.navigation.prev = prevFn

        subPackageModules.device.gameNavigation.next = nextFn
        subPackageModules.device.gameNavigation.prev = nextFn

        subPackageModules.device.triggerOutcome = async function (outcome, isFinal) {
            console.log("device.triggerOutcome", outcome, isFinal, questionIndex)
            let closeBeforeFinal = ((message || {}).quantities || {}).closeBeforeFinal
            
            if (closeBeforeFinal && isFinal) {
                resolveNextQuestion(question, questionIndex, outcome, config.questions.length)
            }
            
            let triggerOutcomeResult = this.quizContainerOriginalTriggerOutcome(outcome)
            if (isFinal) {
                if (config.waitForFinalOutcome) {
                    await triggerOutcomeResult
                }
                
                if (!closeBeforeFinal) {
                    resolveNextQuestion(question, questionIndex, outcome, config.questions.length)
                }
            }
            
            return triggerOutcomeResult
        }
        
        let subPackageMessage = modules.realDevice.allMessages.filter(m => m.systemId === Number(question.question.systemId))
        if(subPackageMessage.length) {
            subPackageModules.subPackageMessage = subPackageMessage[0]
            subPackageModules.locale = subPackageModules.ioc.run("3r/chi/factories/locale", subPackageMessage[0])
        }

        quizModules.push(subPackageModules)
    }

    const resolveNextQuestion = (question, questionIndex, outcome, totalNumberOfQuestions) => {
        if(question.outcomesContainer && (question.outcomesContainer.outcomes || []).length > 0) {
            let resultOutcomes = (question.outcomesContainer.outcomes || []).filter((item) => {
                return item.outcome == outcome
            })

            if(resultOutcomes.length == 0) {
                goToQuestion(questionIndex + 1)
            } else {
                switch(resultOutcomes[0].reactionType) {
                    case 'nextQuestion': {
                        goToQuestion(questionIndex + 1)
                        break;
                    }
                    case 'jumpToQuestion': {
                        goToQuestion(resultOutcomes[0].jumpToQuestionIndex)
                        break;
                    }
                    case 'endQuiz': {
                        goToQuestion(totalNumberOfQuestions)
                        break;
                    }
                    default: {
                        goToQuestion(questionIndex + 1)
                        break;
                    }
                }
            }

        } else {
            goToQuestion(questionIndex + 1)
        }
        
        async function goToQuestion(index) {
            if(modules.realDevice && config.quiz.rememberPositionForQuiz){
                let systemId = message.systemId
                await modules.realDevice.canUpdateData()
                let variables = modules.realDevice.variables || {}
                lodashSet(variables, "quizContainerPackage.systemId_"+systemId+".currentPosition" , index)
                modules.realDevice.variables = variables
        
            }
            
            if (index >= totalNumberOfQuestions) {
                return modules.navigation.next()
            } 
            let nextSystemId = config.questions[index]?.question?.systemId
            
            if(nextSystemId && config.quiz.missingMessageBehaviour !== "none"){
                
                switch (config.quiz.missingMessageBehaviour){
                    case "next" : {
                        let allMessages = modules.realDevice.allMessages.find(item => item?.systemId == nextSystemId)
                        if(!allMessages) goToQuestion(index + 1) 
                        else setCurrentQuestionIndex({ index: index, history: currentQuestionIndex.history.concat([index])})
                        break;
                    }
                    case "wait" : {
                        let allMessagesBefore = modules.realDevice.allMessages.find(item => item?.systemId == nextSystemId)
                        
                        if(!allMessagesBefore){
                            await modules.realDevice.unlock("QuizContainer.message.next")
                            let info = await modules.realDevice.getInfo()
                            let infoMessage = info.messages.find(item => item?.systemId == nextSystemId)
                            if(!infoMessage) goToQuestion(index + 1)
                            else setCurrentQuestionIndex({ index: index, history: currentQuestionIndex.history.concat([index])})
                        }
                        else setCurrentQuestionIndex({ index: index, history: currentQuestionIndex.history.concat([index])})
                        break;
                    }
                    default : {
                        setCurrentQuestionIndex({ index: index, history: currentQuestionIndex.history.concat([index])})
                        break;
                    }
                }
            }else{
                setCurrentQuestionIndex({ index: index, history: currentQuestionIndex.history.concat([index])})
            }
        }
    }

    const startPlay = () => {
        setCurrentQuestionIndex({ index: currentQuestionIndex.index + 1, history : [] })
    }  
    
    if(config.quiz.nextOnRedeem){
        let alreadyRedeemedMessages = []
        modules.realDevice.on('messages', ((messages)=>{
            let currentQuizModule = quizModules[currentQuestionIndex.index]
            let currentShownMessage = quizModules[currentQuestionIndex.index].subPackageMessage
            messages.forEach(message => {
                if(!alreadyRedeemedMessages.includes(message.ATTRIBUTES.id)){
                    if(currentShownMessage.ATTRIBUTES.id == message.ATTRIBUTES.id && message.ATTRIBUTES.status == 'redeemed'){
                        alreadyRedeemedMessages.push(message.ATTRIBUTES.id)
                        currentQuizModule.navigation.next()
                        
                    }
                }
            })
        }))
    }
    
    
    useEffect(() => {
        let prefetchImages = []
        if(currentQuestionIndex.index >= 0 && config.quiz.prefetchImages){
            
            let futureMessages = modules.realDevice.allMessages.find(item => item?.systemId == config.questions[currentQuestionIndex.index + 1]?.question?.systemId)
            
            let threeRadical = ((((futureMessages?.quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
            
            if(threeRadical){
                prefetchImages = resolveImagePath(threeRadical)
            }
            
            prefetchImages.push(futureMessages?.heroImage, futureMessages?.offerImage)
            
            prefetchImages.map(images => {
                const img = new Image();
                img.src = images;
            })
        }
        
        prefetchImages = []
        
    },[currentQuestionIndex])
    
    const resolveImagePath = (parentObj) => {
        let images = []
        
        Object.keys(parentObj).forEach(key => {
            if(typeof parentObj[key] === 'object' && parentObj[key].length == undefined) {
                const { type, value } = parentObj[key]
                if (type && type === 'Image') {
                    if (value) images.push(value)
                } else {
                    images.push(...resolveImagePath(parentObj[key]))
                }
            }
        })
    
        return images
    }

    return (
        <>
            {currentQuestionIndex.index == -1 && 
            <div className="container">
                <QuizIntroduction onPlayStarted={startPlay} ></QuizIntroduction>
            </div>
            }           

            {currentQuestionIndex.index > -1 && currentQuestionIndex.index < config.questions.length &&
                <QuizQuestion 
                    animationType={config.animationType} 
                    animationDuration={config.animationDuration} 
                    animationBackgroundColor={config.animationBackgroundColor}
                    message={message} 
                    modules={quizModules[currentQuestionIndex.index]} 
                    question={config.questions[currentQuestionIndex.index]} 
                    questionIndex={currentQuestionIndex}></QuizQuestion>
            } 

            {currentQuestionIndex.index > -1 && currentQuestionIndex.index == config.questions.length &&
                <div>Finish</div>
            }
        </>
    )
    
    function copyObj(to, from) {
        for (let k in from) {
            if (from.hasOwnProperty(k)) {
                to[k] = from[k]
            }
        }
        
        return to
    }
}
